// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "contact_type": {
      "column": {
        "default": null,
        "name": "contact_type",
        "null": false,
        "type": "string"
      },
      "name": "contact_type",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "translated_contact_type": {
      "column": null,
      "name": "translated_contact_type",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "ActivityPermittedContactType",
  "collectionKey": "activity_permitted_contact_types",
  "collectionName": "activity_permitted_contact_types",
  "i18nKey": "activity_permitted_contact_type",
  "camelizedLower": "activityPermittedContactType",
  "name": "ActivityPermittedContactType",
  "nameDasherized": "activity-permitted-contact-type",
  "pluralName": "activity_permitted_contact_types",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_id",
      "column": {
        "default": null,
        "name": "activity_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "contact_type",
      "column": {
        "default": null,
        "name": "contact_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_activity_id",
      "column": {
        "default": null,
        "name": "old_activity_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "activity_permitted_contact_type",
  "primaryKey": "id"
}

/** Frontend model for ActivityPermittedContactType. */
export default class ActivityPermittedContactType extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  contactType() {
    return this.readAttributeUnderscore("contact_type")
  }

  /** @returns {boolean} */
  hasContactType() {
    const value = this.contactType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedContactType() {
    return this.readAttributeUnderscore("translated_contact_type")
  }

  /** @returns {boolean} */
  hasTranslatedContactType() {
    const value = this.translatedContactType()

    return this._isPresent(value)
  }
}
